import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { loadConfig } from "./api/client.ts";
import { App } from "./app.tsx";
import { initVersionCheck, notifyUpdateAvailable } from "./util/appUpdate.ts";

import "./styles/globals.css";

// A lazy chunk failed to load — almost always a new deploy replaced the content-hashed
// files this (old) tab still references. We do NOT auto-reload: that's jarring and can
// throw away unsaved work. Flag a REQUIRED update so the in-app banner prompts the user to
// reload when they choose. preventDefault stops Vite re-throwing it as an unhandled error.
window.addEventListener("vite:preloadError", (event: Event) => {
  event.preventDefault();
  notifyUpdateAvailable(true);
});

async function bootstrap() {
  await loadConfig();
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
  // Proactively detect new deploys (poll version.txt) so the user is offered the update
  // before they hit a missing chunk. Fire-and-forget.
  void initVersionCheck();
}

bootstrap().catch(console.error);
